import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-address" }
const _hoisted_2 = { class: "top-info flex-left" }
const _hoisted_3 = { class: "adr" }
const _hoisted_4 = { class: "iconfont iconfuzhi" }
const _hoisted_5 = {
  id: "qrcode",
  ref: "qrcode",
  class: "flex-center"
}
const _hoisted_6 = { class: "infos-box table-shadow" }
const _hoisted_7 = { class: "infos-body" }
const _hoisted_8 = { class: "infos-col" }
const _hoisted_9 = { class: "item flex-between" }
const _hoisted_10 = { class: "flex-left item-main" }
const _hoisted_11 = { class: "item flex-left" }
const _hoisted_12 = { class: "infos-col" }
const _hoisted_13 = { class: "item flex-left" }
const _hoisted_14 = { class: "item flex-left token-total-row" }
const _hoisted_15 = { class: "erc20-summary-line" }
const _hoisted_16 = {
  key: 1,
  class: "muted"
}
const _hoisted_17 = { class: "adr-tx-record table-shadow" }
const _hoisted_18 = { class: "trade-select" }
const _hoisted_19 = { class: "total" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "bottom-page flex-right"
}
const _hoisted_22 = { class: "mono-balance" }

import PageContainer from "@/components/mobile/PageContainer.vue";
import { formatTime, filterHash, filterNum } from "@/utils/filters";
import AddressMixins from "@/mixins/address";
import useAddressOverview from "@/mixins/addressOverview";
import { useRoute } from "vue-router";
import { computed, watch, onMounted, ref } from "vue";
import { success, error } from "@/mixins/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'Address',
  setup(__props) {

const route = useRoute();
const addr = computed((): string | undefined => {
  const q = route.query.address;
  if (Array.isArray(q)) return q[0];
  return q;
});

const {
  adrInfo,
  contractInfo,
  contractSearch,
  tokenBalance,
  BASE_COIN_LABEL,
  coinAmount,
  frozenAmount,
  searchContract,
} = useAddressOverview(addr);

const erc20DialogVisible = ref(false);
const tokenPreviewSymbols = computed(() =>
  tokenBalance.value
    .slice(0, 3)
    .map((t) => t.symbol)
    .join("、")
);

const {
  pages,
  txs,
  options,
  filterTrade,
  getTrades,
  getTradesCount,
  pageChange,
  sizeChange,
  drawCode,
  makeCode,
  downCode,
  init,
} = AddressMixins(addr);
onMounted(() => {
  drawCode();
});
watch(
  addr,
  async () => {
    await init();
    txs.list = await getTrades();
    pages.total = await getTradesCount();
    makeCode();
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_clipboard = _resolveDirective("clipboard")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("span", null, "地址", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(filterHash)(addr.value)), 1),
      _withDirectives(_createElementVNode("i", _hoisted_4, null, 512), [
        [_directive_clipboard, addr.value, "copy"],
        [_directive_clipboard, _unref(success), "success"],
        [_directive_clipboard, _unref(error), "error"]
      ]),
      _createVNode(_component_el_popover, {
        placement: "bottom",
        trigger: "click"
      }, {
        reference: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "iconfont iconerweima" }, null, -1)
        ])),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, null, 512),
          _createElementVNode("p", {
            class: "erweima-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downCode)()))
          }, "保存二维码")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "infos-title" }, "概况", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "dot dot-red" }, null, -1)),
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "主币余额", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(coinAmount)(_unref(adrInfo).balance)) + " " + _toDisplayString(_unref(BASE_COIN_LABEL)), 1)
            ]),
            _createVNode(_component_el_select, {
              modelValue: _unref(contractSearch),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(contractSearch) ? (contractSearch).value = $event : null)),
              class: "contract-type",
              placeholder: "合约",
              size: "small",
              onChange: _unref(searchContract)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contractInfo), (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.execer,
                    value: item.execer
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot dot-blue" }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "交易笔数", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(adrInfo).txCount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "dot dot-red" }, null, -1)),
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "冻结", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(frozenAmount)(_unref(adrInfo).frozen)) + " " + _toDisplayString(_unref(BASE_COIN_LABEL)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "dot dot-green" }, null, -1)),
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "ERC20", -1)),
            (_unref(tokenBalance).length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_15, [
                    _cache[13] || (_cache[13] = _createTextVNode(" 共 ")),
                    _createElementVNode("strong", null, _toDisplayString(_unref(tokenBalance).length), 1),
                    _cache[14] || (_cache[14] = _createTextVNode(" 种 ")),
                    (tokenPreviewSymbols.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(tokenPreviewSymbols.value), 1),
                          (_unref(tokenBalance).length > 3)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("…")
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_button, {
                    type: "text",
                    class: "erc20-detail-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (erc20DialogVisible.value = true))
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("查看明细")
                    ])),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_16, "暂无"))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "head" }, [
        _createElementVNode("span", { class: "active-tab" }, "上链记录")
      ], -1)),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_select, {
          modelValue: _unref(txs).txType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(txs).txType) = $event)),
          placeholder: "请选择",
          size: "small",
          class: "tx-select",
          onChange: _unref(filterTrade)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                class: "trade-option",
                key: item,
                label: item,
                value: index
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createElementVNode("span", _hoisted_19, [
          _createTextVNode(" 共找到" + _toDisplayString(_unref(filterNum)(_unref(pages).total) || 0) + "条数据 ", 1),
          (_unref(pages).total > 10000)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "（显示最新的10000条记录）"))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(txs).list,
        stripe: "",
        style: {"width":"100%"},
        class: "data-table",
        "empty-text": "暂无数据",
        "element-loading-text": "拼命加载中...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(255, 255, 255, 0.8)"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "上链哈希",
            width: "188"
          }, {
            default: _withCtx((item) => [
              _createVNode(_component_router_link, {
                to: `/tradeHash?hash=${item.row.hash}`,
                class: "light flex-left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(["iconfont err-ico", {
                'iconjinggao-chucuo':
                  item.row.success === false && item.row.is_para === false,
              }])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_unref(filterHash)(item.row.hash, 12)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "发送方",
            width: "190"
          }, {
            default: _withCtx((item) => [
              _createVNode(_component_router_link, {
                to: `/address?address=${item.row.from}`,
                class: _normalizeClass({
              light: item.row.from !== addr.value,
              base: item.row.from === addr.value,
            })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.from, 12)), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { width: "60" }, {
            default: _withCtx((item) => [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont", {
              iconchu: item.row.from === addr.value,
              iconjin: item.row.to === addr.value,
            }])
              }, null, 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "接收方",
            width: "200"
          }, {
            default: _withCtx((item) => [
              _createVNode(_component_router_link, {
                to: `/address?address=${item.row.to}`,
                class: _normalizeClass({
              light: item.row.to !== addr.value,
              base: item.row.to === addr.value,
            })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.to, 12)), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            width: "120",
            align: "right"
          }, {
            default: _withCtx((item) => [
              _createTextVNode(_toDisplayString(item.row.assets ? _unref(coinAmount)(item.row.assets[0]?.amount / 1e8) + " " +
              (item.row.assets[0].symbol == 'BTY' ?
                _unref(BASE_COIN_LABEL) : item.row.assets[0].symbol) : item.row.amount / 1e8 + " " + _unref(BASE_COIN_LABEL)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "时间",
            width: "170"
          }, {
            default: _withCtx((item) => [
              _createTextVNode(_toDisplayString(_unref(formatTime)(item.row.block_time)), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(txs).loading]
      ])
    ]),
    (_unref(txs).list.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(PageContainer, {
            onPageChange: _unref(pageChange),
            onSizeChange: _unref(sizeChange),
            currentPage: _unref(pages).number,
            pageSize: _unref(pages).size,
            total: _unref(pages).total > 10000 ? 10000 : _unref(pages).total
          }, null, 8, ["onPageChange", "onSizeChange", "currentPage", "pageSize", "total"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: erc20DialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((erc20DialogVisible).value = $event)),
      title: "ERC20 持仓明细",
      width: "92%",
      "custom-class": "erc20-holdings-dialog erc20-holdings-dialog--mobile",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(tokenBalance),
          stripe: "",
          size: "small",
          "max-height": "360",
          "empty-text": "暂无数据"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "symbol",
              label: "符号",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              prop: "nickname",
              label: "名称",
              "min-width": "120",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.nickname || "—"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "余额",
              width: "130",
              align: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", _hoisted_22, _toDisplayString(scope.row.balance), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})